//place in App state
//these are rotating style changes, based on current time;
const backgroundTheme = [
    {
        hour: [2,3,18,19],
        style:
            {
            background: "#354775",
            color: "var(--off-white)",
            fill: "var(--off-white)",
            },
        btnStyle: 
            {
            background: "var(--off-white)",
            color: "#273B70",
            },
    },
    {
        hour: [4,5],
        style: 
            {
            background: "#405896",
            color: "var(--off-white)",
            fill: "var(--off-white)",
            },
        btnStyle:
            {
            background: "var(--off-white)",
            color: "#405896",
            },
    },
    {
        hour: [6,7],
        style:
            {
            background: "#B4DBFF",
            color: "var(--night)",
            fill: "var(--night)",
            },
        btnStyle:
            {
            background: "var(--night)",
            color: "#B4DBFF",
            },
    },
    {
        hour: [8,9],
        style:
            {
            background: "#F2E6BC",
            color: "var(--night)",
            fill: "var(--night)",
            },
        btnStyle:
            {
            background: "var(--night)",
            color: "#F2E6BC",
            },
    },
    {
        hour: [10,11],
        style:
            {
            background: "#FFFEE3",
            color: "var(--night)",
            fill: "var(--night)",
            },
        btnStyle:
            {
            background: "var(--night)",
            color: "#FFFEE3",
            },
    },
    {
        hour: [12,13],
        style:
            {
            background: "#F1F1F1",
            color: "var(--grey)",
            fill: "var(--grey)",
            },
        btnStyle:
            {
            background: "var(--grey)",
            color: "#F1F1F1",
            },
    },
    {
        hour: [14,15],
        style:
            {
            background: "#FFD4C7",
            color: "var(--night)",
            fill: "var(--night)",
            }, 
        btnStyle:
            {
            background: "var(--night)",
            color: "#FFD4C7",
            },
    },
    {
        hour: [16,17],
        style:
            {
            background: "#FFB8A1",
            color: "var(--night)",
            fill: "var(--night)",
            },
        btnStyle:
            {
            background: "var(--night)",
            color: "#FFB8A1",
            },
    },
    {
        hour: [20,21],
        style:
            {
            background: "#1E2946",
            color: "var(--off-white)",
            fill: "var(--off-white)",
            },     
        btnStyle:
            {
            background: "var(--off-white)",
            color: "#1E2946",
            },
    },
    {
        hour: [22,23],
        style:
            {
            background: "#2A353A",
            color: "var(--off-white)",
            fill: "var(--off-white)",
            },
        btnStyle:
            {
            background: "var(--off-white)",
            color: "#2A353A",
            },
    },
    {
        hour: [0,1],
        style:
            {
            background: "#1E2529",
            color: "var(--off-white)",
            fill: "var(--off-white)",
            },
        btnStyle: 
            {
            background: "var(--off-white)",
            color: "#1E2529",
            },
    },

]

export default backgroundTheme;